<ng-container *ngIf="!hasContent">
  <p class="tt-product-cat-tree__empty">{{ emptyMessage }}</p>
</ng-container>

<ul *ngIf="hasContent" class="tt-product-cat-tree">
  <li *ngIf="showAllRow">
    <button
      type="button"
      class="tt-product-cat-tree__row"
      [class.tt-product-cat-tree__row--selected]="selectionEnabled && selectedId === null"
      (click)="onAllClick()"
    >
      {{ allOptionLabel }}
    </button>
  </li>
  <ng-container
    *ngTemplateOutlet="branchTpl; context: { nodes: nodes, depth: 0 }"
  ></ng-container>
</ul>

<ng-template #branchTpl let-nodes="nodes" let-depth="depth">
  <li *ngFor="let node of nodes; trackBy: trackNode" class="tt-product-cat-tree__item">
    <ng-container *ngIf="mode === 'select'; else manageRow">
      <button
        type="button"
        class="tt-product-cat-tree__row"
        [class.tt-product-cat-tree__row--selected]="selectionEnabled && selectedId === node.id"
        [style.paddingLeft.rem]="rowPadding(depth)"
        [attr.aria-expanded]="nodeHasChildren(node) ? isExpanded(node.id) : null"
        (click)="onSelectRowClick($event, node)"
        (dblclick)="onSelectRowDblClick(node)"
      >
        <span
          *ngIf="nodeHasChildren(node)"
          class="tt-cat-tree__chevron"
          [class.tt-cat-tree__chevron--expanded]="isExpanded(node.id)"
          aria-hidden="true"
        ></span>
        <span *ngIf="!nodeHasChildren(node)" class="tt-cat-tree__spacer" aria-hidden="true"></span>
        <span class="tt-product-cat-tree__label tt-cat-tree__text" [ngClass]="nodeLabelClass(node)">{{
          node.label
        }}</span>
      </button>
    </ng-container>

    <ng-template #manageRow>
      <div
        class="tt-product-cat-tree__manage-row"
        [class.tt-product-cat-tree__manage-row--selected]="selectedId === node.id"
        [style.paddingLeft.rem]="rowPadding(depth)"
      >
        <button
          type="button"
          class="tt-product-cat-tree__manage-label"
          (click)="onManageRowClick(node)"
        >
          <span
            *ngIf="showManageChevron(node)"
            class="tt-cat-tree__chevron"
            [class.tt-cat-tree__chevron--expanded]="isExpanded(node.id)"
            aria-hidden="true"
          ></span>
          <span *ngIf="!showManageChevron(node)" class="tt-cat-tree__spacer" aria-hidden="true"></span>
          <span
            class="tt-product-cat-tree__label tt-product-cat-tree__label--strong tt-cat-tree__text"
            [ngClass]="nodeLabelClass(node)"
            >{{ node.label }}</span
          >
          <span *ngIf="node.isSystemRoot" class="tt-product-cat-tree__badge">kořen</span>
        </button>
        <details
          *ngIf="canEdit"
          appDetailsCloseOnOutsideClick
          class="tt-product-cat-tree__menu-details"
          (click)="$event.stopPropagation()"
        >
          <summary
            class="tt-product-cat-tree__menu-trigger"
            [attr.aria-label]="'Akce ' + node.label"
          >
            <span class="tt-product-cat-tree__menu-icon" aria-hidden="true">⋮</span>
          </summary>
          <div class="tt-product-cat-tree__menu" role="menu">
            <button
              type="button"
              role="menuitem"
              class="tt-product-cat-tree__menu-item"
              (click)="onAddChildFromMenu(node, $event)"
            >
              Přidat podkategorii
            </button>
            <button
              *ngIf="canRenameNode(node)"
              type="button"
              role="menuitem"
              class="tt-product-cat-tree__menu-item"
              (click)="onRenameFromMenu(node, $event)"
            >
              {{ renameMenuLabel }}
            </button>
            <button
              *ngIf="showManageSpecs"
              type="button"
              role="menuitem"
              class="tt-product-cat-tree__menu-item"
              (click)="onManageSpecsFromMenu(node, $event)"
            >
              Vlastní specifikace
            </button>
            <button
              *ngIf="canDeleteNode(node)"
              type="button"
              role="menuitem"
              class="tt-product-cat-tree__menu-item tt-product-cat-tree__menu-item--danger"
              (click)="onDeleteFromMenu(node, $event)"
            >
              Smazat
            </button>
          </div>
        </details>
      </div>
    </ng-template>

    <ul *ngIf="nodeHasChildren(node) && isExpanded(node.id)" class="tt-product-cat-tree">
      <ng-container
        *ngTemplateOutlet="branchTpl; context: { nodes: node.children, depth: depth + 1 }"
      ></ng-container>
    </ul>
  </li>
</ng-template>
